module.exports = __webpack_public_path__ + "img/camp04_open.d05822ca.png";